<template>
  <div class="warehousingManagePage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">商务&销售管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">采购管理</div>
    </div>
    <!-- <div class="input_box scan">
      <van-field
        v-model="searchTxt"
        ref="input"
        placeholder="输入SKU编码/ISBN编码查找匹配商品"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>
    <div class="primary-button" @click="handleSearch">查找</div> -->
    <div class="input_wrap flex-rowl">
      <div class="input_box flex-rowl">
        <!-- <input type="text" v-mtfocus placeholder="输入SKU编码/ISBN编码查找匹配商品" > -->
        <van-field
          v-model="searchTxt"
          ref="input"
          @focus="handleFocus"
          @blur="handleBlur"
          placeholder="输入SKU编码/ISBN编码查找"
        />
        <span class="iconfont icon-saoma" @click="handleSance"></span>
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <!-- <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div> -->
    <div class="fixd_button_btm" v-if="isShowTabbar">
      <div class="item" @click="handleReturn">返回</div>
    </div>

    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
let previousRouterName = "";
let previTxt = "";
import storage from "../../utils/storage";
import { queryShop } from "../../api/api";
import { mapState } from "vuex";
// import Tabbar from "../../components/Tabbar.vue";
export default {
  name: "pManageIndex",
  components: {
    // Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,
      searchTxt: "",
    };
  },
  // back 返回页获取参数
  beforeRouteEnter(to, from, next) {
    console.log(to);
    previousRouterName = from.name;
    if (from.name === "qrcode") {
      previTxt = from.params.keyword;
    }
    next();
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    if (previousRouterName === "qrcode") {
      this.searchTxt = previTxt;
    }
  },
  methods: {
    handleReturn() {
      history.back();
    },

    handleSearch() {
      let keyword = this.searchTxt;
      if (keyword == "") {
        this.$toast("请输入SKU编码/ISBN编码");
        return;
      } else {
        const Toast = this.$toast.loading({
          message: "请稍后...",
          forbidClick: true,
        });
        queryShop({ keyword, openid: this.OPENID }).then((res) => {
          if (res.id) {
            // setStorageGoodsDetail("GOODDETAIL", res.data);
            storage.set("GOODDETAIL", res);
            this.$router.push(`/purchaseIndex/pManageList/${keyword}`);
          } else {
            this.$toast("该商品暂不存在");
            return;
          }
          Toast.clear();
        });
      }
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

     // 跳转扫码
    handleSance() {
      this.$router.push("/Qrcode");
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingManagePage {
  // .input_box {
  //   margin-bottom: 117px;
  // }
  .primary-button-plain {
    margin-top: 59px;
  }

  .input_wrap {
    padding: 20px 45px 90px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
}
</style>